import { EditCalendarRounded } from '@mui/icons-material';
import { IconButton, IconButtonProps, SvgIconProps, useTheme } from '@mui/material';

interface IProps {
  buttonProps?: IconButtonProps;
  iconProps?: SvgIconProps;
  isMarked: boolean;
}

const ButtonBookmarkWhite = ({ isMarked, buttonProps, iconProps }: IProps) => {
  const theme = useTheme();

  return (
    <IconButton
      sx={{
        color: isMarked ? theme.palette.primary.main : theme.palette.common.white,
        backgroundColor: isMarked ? theme.palette.common.white : 'transparent',
        fontSize: 16,
        border: `1px solid ${theme.palette.common.white}`,
      }}
      {...buttonProps}
    >
      <EditCalendarRounded fontSize="small" {...iconProps} />
    </IconButton>
  );
};

export default ButtonBookmarkWhite;
